module.exports = __webpack_public_path__ + "static/media/logo_block.0caf77ae.png";